export default __webpack_public_path__ + "static/media/womencare.82f20a98.jpg";